import { useEffect, useState } from 'react'
import './index.scss'

interface DynamicWidthNumberInputProps {
  value: number
  onChange: (value: number) => void
  small?: boolean
  min?: number
  step?: number
}

const DynamicWidthNumberInput = ({ value, onChange, small = false, min, step }: DynamicWidthNumberInputProps) => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    setWidth(value.toString().length * 26)
  }, [value])

  return (
    <input
      className={`component--dynamic-width-number-input ${small ? 'small' : ''}`}
      type="number"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      min={min}
      step={step}
      style={{ width: `${width}px` }}
    />
  )
}

export default DynamicWidthNumberInput
